import { createRoutine } from 'redux-saga-routines';

export const fetchInventoryPackageItems = createRoutine(
  'FETCH_INVENTORY_PACKAGE_ITEMS'
);

export const fetchInventoryPackageActiveReservationOrderItemsCount = createRoutine(
  'FETCH_INVENTORY_PACKAGE_ACTIVE_RESERVATION_ORDER_ITEMS_COUNT'
);

export const fetchInventoryItemOptions = createRoutine(
  'FETCH_INVENTORY_ITEM_OPTIONS'
);

export const fetchInventoryTagOptions = createRoutine(
  'FETCH_INVENTORY_TAG_OPTIONS'
);
